const AUTH_JSON_HEADERS = require('authJsonHeaders')

const camelize = require('../camelize')

module.exports = () => {
  return fetch('/soviet/advices/counters', { headers: AUTH_JSON_HEADERS })
    .then(res => res.json())
    .then(camelize)
}
